import { barcodeDetailApi, getMedicineInvoice, medicineInvoiceCreate, medicineSearch, medicineStats } from "../../constants/apis/clinic_apis";
import axios from "axios";
import { getUserName, getUserRole, getUserToken } from "../../utils/localStoarege";

export const searchMedicineApi = async (name) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${getUserToken()}`,
        },
    };

    const centerName = getUserRole() === 'medical' ? 'Indore' : getUserName();
    const response = await axios.get(
        medicineSearch + "center_name=" + centerName + "&medicine_name=" + name,
        config,
    );

    return response;
};

export const getMedicineInvoiceApi = async (query, centerName) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${getUserToken()}`,
        },
    };

    const center = centerName || (getUserName() !== 'null' ? getUserName() : "");
    const response = await axios.get(
        getMedicineInvoice + center + (query || ""),
        config,
    );

    return response;
};

export const getMedicineStats = async (centerName) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${getUserToken()}`,
        },
    };
    const response = await axios.get(medicineStats + centerName + "/", config);
    return response;
};

export const addNewMedicineInvoices = async (data) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${getUserToken()}`,
        },
    };
    const response = await axios.post(medicineInvoiceCreate, data, config);
    return response;
};


export const scanBarcode = async (barcodeId) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${getUserToken()}`,
        },
    };

    const response = await axios.get(
        barcodeDetailApi + barcodeId + "&center_name=" + getUserName(),
        config,
    );

    return response;
};
